import React, { useState } from 'react';
import { ButtonBase } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import moment from 'moment';


import { DateRangePickerComponent } from '../../../Components/Controls/DateRangePickerComponent/DateRangePickerComponent';
import LeadxchangeClaimedLeads from './Views/LeadxchangeClaimedLeads/LeadxchangeClaimedLeads';
import LeadXchangeDataProvider from './Views/LeadxchangeLeadsView/Context/LeadXchangeData';
import { SelectComponet, TabsComponent , PermissionsComponent } from '../../../Components';
import LeadxchangeDashboard from './Views/LeadxchangeDashboard/LeadxchangeDashboard';
import LeadxchangeLeadsView from './Views/LeadxchangeLeadsView/LeadxchangeLeadsView';
import LeadxchangeOverview from './Views/LeadxchangeOverview/LeadxchangeOverview';
import { leadXChangeLocalePath } from './I18n/LeadXChangeLocale';
import { SharedDataPermissions  } from '../../../Permissions' ; 
import { PageHeading } from '../../../SharedComponents';
import Settings from '../../../assets/icons/settings';
import { GlobalHistory } from '../../../Helper';


import Download04 from '../../../assets/icons/Download04';

import './style.scss';
function LeadXChangeView() {
  const { t: translate } = useTranslation(leadXChangeLocalePath);
  const [currentTab, setCurrentTab] = useState(0);
  const [filter, setFilter] = useState({
    startDate: null,
    endDate: null,
  });

  const handleConfigClick = () => {
    GlobalHistory.push('/home/LeadXchange/LeadXChange-configuration');
  };
  const dateRangeOptions = {
    1: 'All Time',
    2: 'Last 7 Days',
    3: 'Last 30 Days',
  };

  const subTitleText = {
    0: 'get_a_comprehensive',
    1: 'access_and_claim_high_potential',
  };
  return (
    <LeadXchangeDataProvider>
      <div className="propx-view leadxchange-view">
        <div className="d-flex-v-center-h-between" id="page-heading-container">
          <PageHeading
            parentTranslationPath={leadXChangeLocalePath}
            headerTitle={"LeadXchange pool"}
            subTitle={subTitleText[currentTab]}
            wrapperClasses={"px-4 pt-4 w-75"}
            headerTitleClasses={"fz-30  mb-3"}
            subTitleClasses={"m-0"}
          />

          {currentTab === 0 && (
            <div className="dashboard-filter-container">
              {/* <SelectComponet
                data={[
                  { id: '1', name: 'All Time' },
                  { id: '2', name: 'Last 7 Days' },
                  { id: '3', name: 'Last 30 Days' },
                ]}
                valueInput='id'
                textInput='name'
                placeholder='type'
                // emptyItem={{
                //   value: null,
                //   text: 'Select Type ',
                //   isDisabled: false,
                // }}
                value={'1'}
                onSelectChanged={() => {}}
                renderValue={(value) => (
                  <span className='c-black'>{dateRangeOptions[value]}</span>
                )}
                wrapperClasses='fields-content w-auto px-1'
              /> */}
              <DateRangePickerComponent
                wrapperClasses="w-100 styled-data-picker "
                emptyLabel="DD/MM/YYYY"
                ranges={[
                  {
                    startDate: filter.startDate,
                    endDate: moment(filter.endDate),
                    key: "selection",
                  },
                ]}
                onClearClicked={() =>
                  setFilter((prev) => ({
                    ...prev,
                    startDate: null,
                    endDate: null,
                  }))
                }
                onDateChanged={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    startDate: new Date(
                      moment(e.selection.startDate).startOf("day")
                    ),
                    endDate: new Date(moment(e.selection.endDate).endOf("day")),
                  }));
                }}
              />
              {/* <ButtonBase
                className='btns theme-propx solid'
                // onClick={handleClick}
              >
                <div className='btn-download-container'>
                  <Download04
                    width='20px'
                    height='20px'
                    fill={'#FFFFFF'}
                  />
                  <span className='btn-download-text'>
                    Download PDF summary
                  </span>
                </div>
              </ButtonBase> */}
            </div>
          )}
        </div>
        <div className="main-tabs-container">
          <TabsComponent
            wrapperClasses="main-tabs-wrapper"
            data={[
              {
                label: "Dashboard",
                component: LeadxchangeDashboard,
                permissionsList: Object.values(SharedDataPermissions),
                permissionsId:
                  SharedDataPermissions.viewDashboard.permissionsId,
              },
              {
                label: "Leads",
                component: LeadxchangeLeadsView,
                permissionsList: Object.values(SharedDataPermissions),
                permissionsId: SharedDataPermissions.ViewLead.permissionsId,
              },
              // {
              //   label: 'Claimed Leads',
              //   component: LeadxchangeClaimedLeads,
              // },
              // {
              //   label: 'Overview',
              //   component: LeadxchangeOverview,
              // },
            ]}
            orientation="vertical"
            labelInput="label"
            parentTranslationPath={leadXChangeLocalePath}
            themeClasses="theme-propx"
            currentTab={currentTab}
            onTabChanged={(_, second) => setCurrentTab(second)}
            withDynamicComponents
            dynamicComponentProps={{
              parentTranslationPath: leadXChangeLocalePath,
              translate,
              filter,
            }}
            customTab={
              <div className="configuration-tab-container">
                <div className="configuration-label-container">
                  <div className="configuration-label">
                    Configuration Center
                  </div>
                  <span className="configuration-sub-label">
                    Manage pool settings, revenue shares, and campaign overrides
                    for all environments.
                  </span>
                </div>

                <PermissionsComponent
                  permissionsList={Object.values(SharedDataPermissions)}
                  permissionsId={
                    SharedDataPermissions.ManageConfiguration.permissionsId
                  }
                >
                  <ButtonBase
                    className="configuration-button"
                    onClick={handleConfigClick}
                  >
                    <Settings width="20" height="20" fill={"#fff"} />
                    <span className="configuration-label text-configuration">
                      Manage configuration
                    </span>
                  </ButtonBase>
                </PermissionsComponent>
              </div>
            }
          />
        </div>
      </div>
    </LeadXchangeDataProvider>
  );
}

export default LeadXChangeView;
